export default __webpack_public_path__ + "static/media/Arya_Dwiffa.d3993454.png";